import _extends from "@babel/runtime/helpers/extends";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
import _isPlainObject from 'lodash/isPlainObject';
import _reduce from 'lodash/reduce';
import { observable, action } from 'mobx';
import { mapInitialStateToStoreState } from "../../utils/store.utils/index.js";
// temporary solution for global
// TODO need to delete this row after fixing issue with global
var global = globalThis;

/**
 * ABTesting store
 * responsible for managing AB testing flags
 * and provide global access to window
 */
var ABTesting = (_dec = action.bound, _dec2 = action.bound, _dec3 = action.bound, _dec4 = action.bound, _dec5 = action.bound, _dec6 = action.bound, (_class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} initialState
   */
  function ABTesting(initialState) {
    var _this = this;
    if (initialState === void 0) {
      initialState = {};
    }
    _initializerDefineProperty(this, "abTesting", _descriptor, this);
    /**
     * get active ab testing flags
     * @returns {Array}
     */
    this.getActiveABTesting = function () {
      return _reduce(_this.abTesting, function (activeArray, value, key) {
        value && activeArray.push(key);
        return activeArray;
      }, []);
    };
    /**
     * activate ab testing (single flag)
     * @param {String} flagKey
     */
    _initializerDefineProperty(this, "activateABTesting", _descriptor2, this);
    /**
     * deactivate ab testing (single flag)
     * @param {String} flagKey
     */
    _initializerDefineProperty(this, "deactivateABTesting", _descriptor3, this);
    /**
     * run AB testing (single flag or multiple)
     * @param {Object} abTesting
     */
    _initializerDefineProperty(this, "runABTesting", _descriptor4, this);
    /**
     * set AB testing
     * this override the current ab tests, usually used for initial setup
     * @param {Object} abTesting
     */
    _initializerDefineProperty(this, "setABTesting", _descriptor5, this);
    /**
     * assignStorePropsToGlobal
     */
    _initializerDefineProperty(this, "assignStorePropsToGlobal", _descriptor6, this);
    this.updateInitialState(initialState);
    this.assignStorePropsToGlobal();
  }
  var _proto = ABTesting.prototype;
  /**
   * update initial state
   * @param {Object} initialState
   */
  _proto.updateInitialState = function updateInitialState(initialState) {
    mapInitialStateToStoreState(this, initialState);
  };
  return ABTesting;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "abTesting", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "activateABTesting", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this2 = this;
    return function (flagKey) {
      var _extends2;
      _this2.abTesting = _extends({}, _this2.abTesting, (_extends2 = {}, _extends2[flagKey] = true, _extends2));
    };
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "deactivateABTesting", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;
    return function (flagKey) {
      var _extends3;
      _this3.abTesting = _extends({}, _this3.abTesting, (_extends3 = {}, _extends3[flagKey] = false, _extends3));
    };
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "runABTesting", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;
    return function (abTesting) {
      if (_isPlainObject(abTesting)) {
        _this4.abTesting = _extends({}, _this4.abTesting, abTesting);
      } else {}
    };
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "setABTesting", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this5 = this;
    return function (abTesting) {
      if (_isPlainObject(abTesting)) {
        _this5.abTesting = abTesting;
      } else {}
    };
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "assignStorePropsToGlobal", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this6 = this;
    return function () {
      var getActiveABTesting = _this6.getActiveABTesting,
        activateABTesting = _this6.activateABTesting,
        deactivateABTesting = _this6.deactivateABTesting,
        setABTesting = _this6.setABTesting,
        runABTesting = _this6.runABTesting;
      Object.assign(global, {
        getActiveABTesting: getActiveABTesting,
        activateABTesting: activateABTesting,
        deactivateABTesting: deactivateABTesting,
        setABTesting: setABTesting,
        runABTesting: runABTesting
      });
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "updateInitialState", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype)), _class));
export { ABTesting as default };